// A stored answer's links are rebuilt from its Markdown when the editor opens: the Nth link in the content takes the
// address of the Nth `[text](url)` in the source. A picture, `![alt](url)`, has the same shape, so it has to be left
// out of that list, or every link after a picture takes the address of the one before it - and the next save writes
// the wrong addresses into the answer. The pattern used to try with `(?![!])`, a lookahead, which looks at the `[`
// itself and so never skipped anything (f79d278c2, 2022, replacing a lookbehind Safari could not run then).

const LINK = /\[([^\]]*)]\s*\(([^)"]+)( "([^)"]+)")?\)/g;

/** Each link's address, in the order the links appear - pictures left out. */
export const markdownLinkUrls = (markdown: string): string[] => {
  const urls: string[] = [];
  for (const match of (markdown ?? '').matchAll(LINK)) {
    if (match.index > 0 && markdown[match.index - 1] === '!') continue;
    urls.push(match[2]);
  }
  return urls;
};
